<template>
	<v-layout row wrap>
		<v-flex v-if="!mobileSize" xs6 md2>
			<div>
				<strong>Waste Form Request ID:</strong>
			</div>
			{{ form.requestId }}
		</v-flex>
		<v-flex xs6 sm4 md2>
			<div>
				<strong>Contact Person:</strong>
			</div>
			<div>{{ form.fName }} {{ form.lName }}</div>
		</v-flex>
		<v-flex v-if="mobileSize" xs6 sm4>
			<div>
				<strong>Contact Number:</strong>
			</div>
			<div>{{ form.phone }}</div>
		</v-flex>
		<v-flex v-else xs6 sm4 md2>
			<div>
				<strong>Contact Number:</strong>
			</div>
			<div>{{ form.phone }}</div>
		</v-flex>
		<v-flex xs6 sm4 md2 :class="mobileSize ? 'mt-3' : ''">
			<div>
				<strong>Building:</strong>
			</div>
			<div>{{ form.building }}</div>
		</v-flex>
		<v-flex xs6 sm4 md2 :class="mobileSize ? 'mt-3' : ''">
			<div>
				<strong>Department Name:</strong>
			</div>
			<div>
				{{ form.formType === "regular" ? form.deptLocation : form.department }}
			</div>
		</v-flex>
		<v-flex xs12 sm4 md2 :class="mobileSize ? 'mt-3' : ''">
			<div>
				<strong>Location Description:</strong>
			</div>
			<div>{{ form.locDesc }}</div>
		</v-flex>
		<v-flex
			xs12
			sm4
			md4
			:class="mobileSize ? 'mt-3' : ''"
			v-if="mobileSize && form.requestDetails.length"
		>
			<div>
				<strong>Request Details:</strong>
			</div>
			<div>{{ form.requestDetails }}</div>
		</v-flex>
		<v-flex xs12 sm4 md2 :class="mobileSize ? 'mt-3' : ''">
			<div>
				<strong>Status:</strong>
			</div>
			<div>{{ form.status }}</div>
		</v-flex>
		<v-flex v-if="!mobileSize" md2>
			<div>
				<strong>{{
					form.status === "Closed" ? "Chargeable" : "Days Open:"
				}}</strong>
			</div>
			<div>
				{{
					form.status === "Closed"
						? form.chargeable
							? "Yes"
							: "No"
						: numberOfDaysOpen(form.requestId, form.status)
				}}
			</div>
		</v-flex>
		<v-flex xs6 sm4 md2 :class="mobileSize ? 'mt-3' : ''">
			<div>
				<strong>Open Date:</strong>
			</div>
			<div>
				{{
					form.openedDate && form.openedDate.seconds
						? parseDate(form.openedDate.seconds * 1000)
						: form.requestId.slice(0, 4) +
							"-" +
							form.requestId.slice(4, 6) +
							"-" +
							form.requestId.slice(6, 8)
				}}
			</div>
		</v-flex>
		<v-flex xs6 sm4 md2 :class="mobileSize ? 'mt-3' : ''">
			<div>
				<strong>Close Date:</strong>
			</div>
			<div>
				{{
					form.closedDate && form.closedDate.seconds
						? parseDate(form.closedDate.seconds * 1000)
						: form.closedDate
							? form.closedDate
							: ""
				}}
			</div>
		</v-flex>
		<v-flex xs12 sm4 md4 :class="mobileSize ? 'mt-3' : ''" v-if="!mobileSize">
			<div>
				<strong>Request Details:</strong>
			</div>
			<div>{{ form.requestDetails }}</div>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	name: "Card",
	props: ["form", "numberOfDaysOpen", "mobileSize", "parseDate"],
};
</script>

<style></style>
